module.exports = __webpack_public_path__ + "img/evonik.6cb51c7e.png";